import { Union } from "./fable_modules/fable-library.3.7.18/Types.js";
import { union_type, tuple_type, list_type, string_type } from "./fable_modules/fable-library.3.7.18/Reflection.js";
import { FSharpResult$2 } from "./fable_modules/fable-library.3.7.18/Choice.js";
import { ofArray, length, getSlice, append, singleton } from "./fable_modules/fable-library.3.7.18/List.js";
import { Cmd_none } from "./fable_modules/Fable.Elmish.4.0.0-beta-3/cmd.fs.js";
import { printf, toText, join } from "./fable_modules/fable-library.3.7.18/String.js";
import { Cmd_OfAsync_start, Cmd_OfAsyncWith_perform } from "./fable_modules/Fable.Elmish.4.0.0-beta-3/./cmd.fs.js";
import { singleton as singleton_1 } from "./fable_modules/fable-library.3.7.18/AsyncBuilder.js";
import { Http_get } from "./fable_modules/Fable.SimpleHttp.3.5.0/Http.fs.js";
import { createElement, memo } from "react";
import * as react from "react";
import { useReact_useCallback_93353E } from "./fable_modules/Feliz.1.68.0/React.fs.js";
import { SampleViewer } from "./SampleViewer.fs.js";
import { Code } from "./CommonViews.fs.js";
import { MuiHelpers_createElement } from "../../src/Feliz.MaterialUI/./Mui.fs.js";
import { Link, IconButton, Tooltip, Typography, Skeleton } from "@mui/material";
import Edit from "@mui/icons-material/Edit";
import { Interop_reactApi } from "./fable_modules/Feliz.1.68.0/./Interop.fs.js";
import { empty, singleton as singleton_2, append as append_1, delay, toList } from "./fable_modules/fable-library.3.7.18/Seq.js";
import { Interop_reactApi as Interop_reactApi_1 } from "./fable_modules/Feliz.Markdown.1.3.1/../Feliz.1.68.0/Interop.fs.js";
import react_markdown from "react-markdown";
import { createObj } from "./fable_modules/fable-library.3.7.18/Util.js";
import { useFeliz_React__React_useElmish_Static_B42E862 } from "./fable_modules/Feliz.UseElmish.1.6.0/UseElmish.fs.js";

export class State extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Initial", "Loading", "Loaded"];
    }
}

export function State$reflection() {
    return union_type("MarkdonViewer.State", [], State, () => [[], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [tuple_type(list_type(string_type), string_type), string_type], FSharpResult$2, () => [[["ResultValue", tuple_type(list_type(string_type), string_type)]], [["ErrorValue", string_type]]])]]]);
}

export class Msg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["StartLoad", "LoadCompleted"];
    }
}

export function Msg$reflection() {
    return union_type("MarkdonViewer.Msg", [], Msg, () => [[["path", list_type(string_type)]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [tuple_type(list_type(string_type), string_type), string_type], FSharpResult$2, () => [[["ResultValue", tuple_type(list_type(string_type), string_type)]], [["ErrorValue", string_type]]])]]]);
}

export function init(path) {
    return [new State(0), singleton((dispatch) => {
        dispatch(new Msg(0, path));
    })];
}

export function update(msg, state) {
    if (msg.tag === 1) {
        return [new State(2, msg.fields[0]), Cmd_none()];
    }
    else {
        const path = msg.fields[0];
        const url = join("/", path);
        return [new State(1), Cmd_OfAsyncWith_perform((x) => {
            Cmd_OfAsync_start(x);
        }, () => singleton_1.Delay(() => singleton_1.Bind(Http_get(url), (_arg) => {
            const statusCode = _arg[0] | 0;
            return (statusCode === 200) ? singleton_1.Return(new FSharpResult$2(0, [path, _arg[1]])) : singleton_1.Return(new FSharpResult$2(1, toText(printf("Failed with status %i when loading %s"))(statusCode)(url)));
        })), void 0, (arg_2) => (new Msg(1, arg_2)))];
    }
}

export const MarkdownLoaderView = memo((markdownLoaderViewInputProps) => {
    let props_7, properties_1;
    const dispatch = markdownLoaderViewInputProps.dispatch;
    const state = markdownLoaderViewInputProps.state;
    const markdownCodeRender = useReact_useCallback_93353E((props) => {
        let pattern_matching_result, path;
        if (state.tag === 2) {
            if (state.fields[0].tag === 0) {
                pattern_matching_result = 0;
                path = state.fields[0].fields[0][0];
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                if (props.language === "sample") {
                    const path_1 = append(getSlice(0, length(path) - 2, path), singleton(props.value));
                    return createElement(SampleViewer, {
                        path: path_1,
                    });
                }
                else {
                    return createElement(Code, {
                        language: props.language,
                        code: props.value,
                    });
                }
            }
            case 1: {
                return null;
            }
        }
    }, [state]);
    if (state.tag === 1) {
        const xs = [MuiHelpers_createElement(Skeleton, [["variant", "text"], ["height", 3 + "em"], ["width", 500]]), MuiHelpers_createElement(Skeleton, [["variant", "text"], ["height", 1 + "em"], ["width", 300]]), MuiHelpers_createElement(Skeleton, [["variant", "text"], ["height", 1 + "em"], ["width", 200]]), MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["height", 200], ["width", 500]])];
        return react.createElement(react.Fragment, {}, ...xs);
    }
    else if (state.tag === 2) {
        if (state.fields[0].tag === 1) {
            return MuiHelpers_createElement(Typography, [["sx", (delegateArg) => ((x) => ({
                color: x.palette.error.main,
            }))(delegateArg)], ["paragraph", true], ["children", state.fields[0].fields[0]]]);
        }
        else {
            const xs_1 = [MuiHelpers_createElement(Tooltip, [["title", "Edit this page"], ["children", MuiHelpers_createElement(IconButton, [["style", {
                float: "right",
            }], ["href", "https://github.com/ArtemyB/Feliz.MaterialUI/edit/master/docs-app/public/" + join("/", state.fields[0].fields[0][0])], ["component", "a"], ["children", (props_7 = {}, react.createElement(Edit, props_7))]])]]), (properties_1 = ofArray([["source", state.fields[0].fields[0][1]], ["escapeHtml", false], ["renderers", {
                paragraph: (props_10) => {
                    let elements;
                    return MuiHelpers_createElement(Typography, [["paragraph", true], (elements = props_10.children, ["children", Interop_reactApi.Children.toArray(Array.from(elements))])]);
                },
                link: (props_12) => {
                    let elements_1;
                    return MuiHelpers_createElement(Link, [["href", props_12.href], (elements_1 = props_12.children, ["children", Interop_reactApi.Children.toArray(Array.from(elements_1))])]);
                },
                code: markdownCodeRender,
                heading: (props_14) => MuiHelpers_createElement(Typography, toList(delay(() => {
                    let matchValue;
                    return append_1((matchValue = (props_14.level | 0), (matchValue === 1) ? singleton_2(["variant", "h1"]) : ((matchValue === 2) ? singleton_2(["variant", "h2"]) : ((matchValue === 3) ? singleton_2(["variant", "h3"]) : ((matchValue === 4) ? singleton_2(["variant", "h4"]) : ((matchValue === 5) ? singleton_2(["variant", "h5"]) : ((matchValue === 6) ? singleton_2(["variant", "h6"]) : ((empty())))))))), delay(() => append_1(singleton_2(["paragraph", true]), delay(() => {
                        let elements_2;
                        return singleton_2((elements_2 = props_14.children, ["children", Interop_reactApi.Children.toArray(Array.from(elements_2))]));
                    }))));
                }))),
            }]]), Interop_reactApi_1.createElement(react_markdown, createObj(properties_1)))];
            return react.createElement(react.Fragment, {}, ...xs_1);
        }
    }
    else {
        return null;
    }
});

export const MarkdownViewer = memo((markdownViewerInputProps) => {
    const path = markdownViewerInputProps.path;
    const patternInput = useFeliz_React__React_useElmish_Static_B42E862(() => init(path), update, [path]);
    return createElement(MarkdownLoaderView, {
        state: patternInput[0],
        dispatch: patternInput[1],
    });
});

